import {Node} from "../../../model/Graph";
import {getVoMetadata} from "./get-vo-metadata";

export const isQueryableVo = (vo: Node): boolean => {
  const voMeta = getVoMetadata(vo);
  return !!voMeta.querySchema;
}
